import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { BaseRoute } from '../shared/components/routes/BaseRoute';
import LoginPage from '../pages/public/login';
import PasswordResetRequestPage from '../pages/public/passwordResetRequest';
import EmailVerificationPage from '../pages/public/emailVerify';
import PrivacyPolicyPage from '../pages/public/privacyPolicy';
import PasswordResetPage from '../pages/public/passwordReset';

// TODO -  Remvove Development Routes
import { DevelopmentRouter } from '../pages/development/Development.router';
import DeletionVerificationPage from '../pages/public/deletionVerify';
import DeleteUserPage from '../pages/public/deleteUser/deleteUser.page';

function PublicRouter(): JSX.Element {
  return (
    <Routes>
      <Route
        path=''
        element={
          <BaseRoute>
            <LoginPage />
          </BaseRoute>
        }
      />
      <Route
        path='user-delete/:community'
        element={
          <BaseRoute>
            <DeleteUserPage />
          </BaseRoute>
        }
      />
      <Route
        path='reset-request'
        element={
          <BaseRoute>
            <PasswordResetRequestPage />
          </BaseRoute>
        }
      />
      <Route
        path='password-reset/:token'
        element={
          <BaseRoute withAuth={true}>
            <PasswordResetPage />
          </BaseRoute>
        }
      />
      <Route
        path='email-verification/:token?'
        element={
          <BaseRoute withAuth={true}>
            <EmailVerificationPage />
          </BaseRoute>
        }
      />
      <Route
        path='deletion-confirmation/:token?'
        element={
          <BaseRoute withAuth={true}>
            <DeletionVerificationPage />
          </BaseRoute>
        }
      />

      <Route
        path='privacy-policy/:slug?'
        element={
          <BaseRoute withAuth={true}>
            <PrivacyPolicyPage />
          </BaseRoute>
        }
      />

      {process.env.NODE_ENV !== 'production' && (
        <Route
          path='development/*'
          element={
            <BaseRoute withAuth={true}>
              <DevelopmentRouter />
            </BaseRoute>
          }
        />
      )}

      <Route
        path='*'
        element={
          <BaseRoute>
            <Navigate to='/' replace={true} />
          </BaseRoute>
        }
      />
    </Routes>
  );
}

export default PublicRouter;
